import { AppNS, Dcra } from 'app';

export const prepareJobData = (data: Dcra.Inspection): AppNS.Params => {
  const pickedPermits = data.pickedPermits.filter((permit) => {
    return (
      permit.isOn &&
      data.permits.find((originalPermit) => originalPermit.id === permit.id)
    );
  });

  const permits = pickedPermits.map((pickedPermit: AppNS.PickedPermit) => {
    let permit = data.permits.find((permit) => permit.id === pickedPermit.id);
    return {
      inspection_group: pickedPermit.inspectionGroup,
      inspection_types: pickedPermit.inspections,
      wall_check_required: pickedPermit.wallCheckRequired,
      wall_check_complete: pickedPermit.wallCheckComplete,
      cluster: pickedPermit.cluster || permit.cluster,
      permit_number: pickedPermit.id,
      scope: permit.scope || '',
    };
  });

  const cluster = pickedPermits.find((permit: AppNS.PickedPermit) => (permit.cluster))?.cluster || '99';

  return {
    properties: {
      client_id: data.clientId,
      address_ids: data.addressIds,
      cluster: cluster,
      date: data.date,
      site_contact_name: data.siteContactName,
      site_contact_email: data.siteContactEmail,
      site_contact_phone: data.siteContactPhone,
      inspector_id: data.inspectorId,
      street_no:
        data.address?.streetNumber || data.dbAddress?.streetNumber || '',
      street_no_suffix: data.address?.streetNumberSuffix || '',
      street_name: data.address?.streetName || data.dbAddress?.streetName || '',
      street_type: data.address?.streetType || data.dbAddress?.streetType || '',
      street_unit_no: data.address?.unitNumber || '',
      quadrant: data.address?.quadrant || data.dbAddress?.quadrant || '',
      zip: data.address?.zip || '',
      permits,
    },
  };
};
